import React, { useContext, useEffect, useState } from "react";
import SideNav from "../components/SideNav"; 
 
import { Context } from "../components/contexts/AppContext";

import Icons from "../components/Icons/index";
 
import { useNavigate } from "react-router-dom";
import Pricing from "./Pricing";
import { getData } from "../lib/utils";
import CheckOut from "./CheckOut";
function Home() {

 console.log("HOME...")

   const { value } = useContext(Context);  
   const [appState, setAppState] = value; 
  const [modalOpen, setModalOpen] = useState(appState.modalData);
  let [temp, setTemp] = useState("NewFolderModal");
   
  let PropertyObj = Icons[temp]; 
    const navigate = useNavigate(); 
 

useEffect(() => {
  setModalOpen(appState.modalData); // modalOpen को अपडेट करें
}, [appState.modalData]);
 
useEffect(() => {
  const fetchData = async () => {
    try {
      const response = await getData("admin/admin-details");
      console.log("RESPONSE NOW", response.admin);
      setAppState((prevState) => {
        return { ...prevState, 
          adminDetails:response.admin,
       
        
        };
      });
    } catch (error) {
      console.error("Error fetching admin details:", error);
    }
  };

  fetchData();
}, []);

  useEffect(() => {
    console.log("Open Modal Type ---",modalOpen.type)
    if (modalOpen.type === "NewFolderModal") {
      PropertyObj = Icons[modalOpen.type];
      setTemp(String("NewFolderModal"));
    }
    else  if (modalOpen.type === "NewGalleryModal") {
      PropertyObj = Icons["NewGalleryModal"];
      setTemp(String("NewGalleryModal"));
    }

    else  if (modalOpen.type === "NewTemplateModal") {
      PropertyObj = Icons["NewTemplateModal"];
      setTemp(String("NewTemplateModal"));
    }
    else  if (modalOpen.type === "RenameModal" || modalOpen.type== "RenameGalleryModal") {
      PropertyObj = Icons["RenameModal"];
      setTemp(String("RenameModal"));
    }
   
  }, [modalOpen?.isOpen]);
  return (
    <>
       
       <SideNav/>
     
      
        
       
        {modalOpen.isOpen ? (
          <>
            <div id="MODAL_POPUP">
              <PropertyObj />
            </div>
          </>
        ) : (
          <></>
        )}

         
 
    </>
  );
}

export default Home;
